
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1c6qp_201",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1c6qp_1",
  "root": "awsui_root_mx3cw_1c6qp_272",
  "hidden": "awsui_hidden_mx3cw_1c6qp_307",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_1c6qp_370",
  "initial-hidden": "awsui_initial-hidden_mx3cw_1c6qp_382",
  "header": "awsui_header_mx3cw_1c6qp_387",
  "header-replacement": "awsui_header-replacement_mx3cw_1c6qp_388",
  "action": "awsui_action_mx3cw_1c6qp_392",
  "action-slot": "awsui_action-slot_mx3cw_1c6qp_396",
  "action-button": "awsui_action-button_mx3cw_1c6qp_397",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1c6qp_401",
  "icon": "awsui_icon_mx3cw_1c6qp_433",
  "text": "awsui_text_mx3cw_1c6qp_437",
  "message": "awsui_message_mx3cw_1c6qp_447",
  "action-wrapped": "awsui_action-wrapped_mx3cw_1c6qp_451",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1c6qp_455",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1c6qp_459",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1c6qp_463",
  "content": "awsui_content_mx3cw_1c6qp_467",
  "content-replacement": "awsui_content-replacement_mx3cw_1c6qp_468",
  "dismiss": "awsui_dismiss_mx3cw_1c6qp_472",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1c6qp_478",
  "type-error": "awsui_type-error_mx3cw_1c6qp_482",
  "type-warning": "awsui_type-warning_mx3cw_1c6qp_490",
  "type-success": "awsui_type-success_mx3cw_1c6qp_498",
  "type-info": "awsui_type-info_mx3cw_1c6qp_506"
};
  